// Resolves an X (Twitter) post to a playable mp4 through our own Cloud
// Function `resolveXVideo` (cached server-side in Firestore).

import { httpsCallable } from "firebase/functions";
import { functions } from "../utils/firebase";

export interface XVideo {
  mp4URL: string;
  posterURL?: string;
}

const memo = new Map<string, Promise<XVideo | null>>();

export function resolveXVideo(tweetId: string): Promise<XVideo | null> {
  if (!memo.has(tweetId)) {
    const call = httpsCallable<{ tweetId: string }, XVideo>(functions, "resolveXVideo");
    memo.set(
      tweetId,
      call({ tweetId })
        .then((res) => res.data)
        .catch((err) => {
          console.error("Unable to resolve X video:", err);
          memo.delete(tweetId);
          return null;
        }),
    );
  }
  return memo.get(tweetId)!;
}
